import { AppTask } from 'aurelia';
import { IAppService } from '../resources/services/app-service';
export const AppClientTask = (appClientType, appClientInstance) => AppTask.creating(IAppService, (app) => {
    app.setAppClientType(appClientType);
    app.setAppClientInstance(appClientInstance);
});
